import { render, staticRenderFns } from "./AssessmentManager.vue?vue&type=template&id=90a23e24&"
import script from "./AssessmentManager.vue?vue&type=script&lang=js&"
export * from "./AssessmentManager.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentManager.vue?vue&type=style&index=0&id=90a23e24&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports